import React from 'react';
import moment from 'moment';
import styles from './pickupTracking.scss';
import {
  getRetailTableCellObject,
  trackCN,
  toTitleCase,
  dateFormatter
} from '../../../../services/helpers';

const formatConsignmentStatus = consignment => {
  let formattedConsignmentStatus = '';
  let consignmentStatus = consignment.status;
  switch (consignmentStatus) {
    case 'CREATED':
      formattedConsignmentStatus = 'Created';
      break;
    case 'INTRANSIT_TO_OU':
      formattedConsignmentStatus = consignment.presentLocation
        ? 'In-transit' + ' to ' + consignment.presentLocation
        : 'In-transit to ou';
      break;
    case 'LOADED':
      formattedConsignmentStatus = 'Loaded';
      break;
    case 'RECEIVED_AT_OU':
      formattedConsignmentStatus = consignment.presentLocation
        ? 'Received' + ' at ' + consignment.presentLocation
        : 'Received at ou';
      break;
    case 'READY_FOR_DF':
      formattedConsignmentStatus =
        'Ready for DF' +
        (consignment.toHubName ? ' at ' + consignment.toHubName : '');
      break;
    case 'DELIVERY_PLANNED':
      formattedConsignmentStatus = 'In-transit';
      break;
    case 'DELIVERY_LOADED':
      formattedConsignmentStatus = 'Loaded';
      break;
    case 'OUT_FOR_DELIVERY':
      formattedConsignmentStatus = 'Out for delivery';
      break;
    case 'UNDELIVERED':
      formattedConsignmentStatus = 'Undelivered';
      break;
    case 'DELIVERED':
      formattedConsignmentStatus = 'Delivered';
      break;
    default:
      formattedConsignmentStatus = toTitleCase(consignmentStatus);
      break;
  }
  return formattedConsignmentStatus;
};

export const cnTableConfig = {
  columns: [
    {
      Header: 'CNs',
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: 'cnote',
      Cell: row => (
        <div>
          <div className={`${styles.texttable}`}>
            {getRetailTableCellObject(
              row.original && row.original.cnote,
              '',
              row.original,
              trackCN,
              'cn-highlight'
            )}
          </div>
        </div>
      )
    },
    {
      Header: () => (
        <div>
          <div>From</div>
          <div>Location </div>
        </div>
      ),
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: true,
      key: 'fromBranchName',
      Cell: row => (
        <div className={`${styles.texttable}`}>
          {row.original.fromBranchName || ' '}
        </div>
      )
    },
    {
      Header: () => (
        <div>
          <div>To</div>
          <div>Location</div>
        </div>
      ),
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: true,
      key: 'toBranchName',
      Cell: row => (
        <div className={`${styles.texttable}`}>
          {row.original.toBranchName || ' '}
        </div>
      )
    },
    {
      Header: () => (
        <div>
          <div>Consignee</div>
          <div>Name</div>
        </div>
      ),
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: true,
      key: 'consigneeName',
      Cell: row => (
        <div className={`${styles.texttable}`}>
          {toTitleCase(row.original.consigneeName)}
        </div>
      )
    },
    {
      Header: () => (
        <div>
          <div>Consignee</div>
          <div>Address</div>
        </div>
      ),
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: true,
      key: 'consigneeAddress',
      Cell: row => (
        <div className={`${styles.texttable}`}>
          {row.original.consigneeAddress}
        </div>
      )
    },
    {
      Header: () => (
        <div>
          <div>Weight</div>
          <div>(in kg.s)</div>
        </div>
      ),
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: 'weight',
      Cell: row => (
        <div className={`${styles.texttable}`}>
          {row.original.weight ? row.original.weight : '--'}
        </div>
      )
    },
    {
      Header: 'Pkgs',
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11 textrow',
      sortable: false,
      key: 'totalBoxes',
      Cell: row => (
        <div className={`${styles.texttable}`}>{row.original.totalBoxes}</div>
      )
    },
    {
      Header: () => (
        <div>
          <div>Estimated</div>
          <div>delivery date</div>
        </div>
      ),
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: 'promisedDeliveryDateTime',
      Cell: row => (
        <div className={`${styles.texttable}`}>
          {dateFormatter(row.original.promisedDeliveryDateTime, true) || '--'}
        </div>
      )
    },
    {
      Header: () => (
        <div>
          <div>Actual delivery</div>
          <div>date & time</div>
        </div>
      ),
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: 'deliveryDateTime',
      Cell: row => (
        <div className={`${styles.texttable}`}>
          {dateFormatter(row.original.deliveryDateTime, false) || '--'}
        </div>
      )
    },
    {
      Header: 'PRS ID',
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: 'prsId',
      Cell: row => (
        <div className={`${styles.texttable}`}>
          {row.original.prsId ? row.original.prsId : '--'}
        </div>
      )
    },
    {
      Header: 'Status',
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: 'status',
      Cell: row => (
        <div className={`${styles.texttable}`}>
          {formatConsignmentStatus(row.original) || ' '}
        </div>
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: "No CN's to Track",
  minRows: 0,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 18rem)' }
};

export default cnTableConfig;
export const trackingDashboardTableActionConfig = {};
